// Rating configuration — edit these values to update both the footer badge and JSON-LD schema
export const ratingConfig = {
  /** The product/service name shown in schema.org markup */
  productName: "AdressFinder.org – Online-Adressauskunft aus dem Melderegister",
  /** Canonical site URL used in the Product schema */
  productUrl: "https://www.adressfinder.org",
  /** Average rating value (1–5 scale) */
  ratingValue: 4.7,
  /** Total number of ratings/reviews */
  ratingCount: 259,
  /** Maximum possible rating */
  bestRating: 5,
  /** Minimum possible rating */
  worstRating: 1,
} as const;

/** Pre-built JSON-LD object ready for injection into <head> */
export function buildProductRatingSchema() {
  return {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: ratingConfig.productName,
    url: ratingConfig.productUrl,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: ratingConfig.ratingValue,
      ratingCount: ratingConfig.ratingCount,
      bestRating: ratingConfig.bestRating,
      worstRating: ratingConfig.worstRating,
    },
  };
}
